const FETCH_PARAM_MAPPINGS = "param-mappings::load";

export { FETCH_PARAM_MAPPINGS };
